// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ActiveState } from "./active-state";
import { ConflictPolicy } from "./conflict-policy";
import { ModifierAction, ModifierActionT, verifyModifierAction } from "./modifier-action";
import {
  ModifierCondition,
  ModifierConditionT,
  verifyModifierCondition,
} from "./modifier-condition";
import { ModifierDirection } from "./modifier-direction";
import { ModifierDropAction } from "./modifier-drop-action";
import {
  ModifierSequenceStep,
  ModifierSequenceStepT,
  verifyModifierSequenceStep,
} from "./modifier-sequence-step";
import {
  ModifierStateCondition,
  ModifierStateConditionT,
  verifyModifierStateCondition,
} from "./modifier-state-condition";
import { ModifierTimeoutPolicy } from "./modifier-timeout-policy";
import { ModifierType } from "./modifier-type";
import { ValueTransformMode } from "./value-transform-mode";
import { ControlMessage, ControlMessageT, verifyControlMessage } from "../control/control-message";
import {
  ControllerInfoMessage,
  ControllerInfoMessageT,
  verifyControllerInfoMessage,
} from "../controller-info/controller-info-message";
import { FaultMessage, FaultMessageT, verifyFaultMessage } from "../fault/fault-message";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";
import {
  GroupControlMessage,
  GroupControlMessageT,
  verifyGroupControlMessage,
} from "../group-control/group-control-message";
import {
  GroupSupervisoryStatusMessage,
  GroupSupervisoryStatusMessageT,
  verifyGroupSupervisoryStatusMessage,
} from "../group-supervisory-status/group-supervisory-status-message";
import { Message, MessageT, verifyMessage } from "../ln2/message";
import {
  MessageContent,
  unionToMessageContent,
  unionListToMessageContent,
} from "../ln2/message-content";
import { ServiceMessage, ServiceMessageT, verifyServiceMessage } from "../service/service-message";
import { StatusMessage, StatusMessageT, verifyStatusMessage } from "../status/status-message";
import { TrafficMessage, TrafficMessageT, verifyTrafficMessage } from "../traffic/traffic-message";
import { UsageMessage, UsageMessageT, verifyUsageMessage } from "../usage/usage-message";

/**
 * A channel modifier rule.
 *
 * For BEFORE/AFTER: `payload` carries the message to emit on the target channel.
 * For IN_FLIGHT: `conditions` and `actions` describe the field mutation.
 *
 * The message kinds are carried as scalars: `source_message_content` and
 * `source_message_value` (v4) for the source leaf the modifier fires on, and
 * `target_message_content` for the kind it targets. A source kind of NONE (the
 * default) fires the modifier for any source message. The `source_message_type`
 * and `target_message_type` unions predate the scalars and are retained for
 * wire compatibility; see each scalar for why.
 */
export class ChannelModifier implements flatbuffers.IUnpackableObject<ChannelModifierT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ChannelModifier {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsChannelModifier(
    bb: flatbuffers.ByteBuffer,
    obj?: ChannelModifier,
  ): ChannelModifier {
    return (obj || new ChannelModifier()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsChannelModifier(
    bb: flatbuffers.ByteBuffer,
    obj?: ChannelModifier,
  ): ChannelModifier {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ChannelModifier()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  sourceChannelId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  targetChannelId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  description(): string | null;
  description(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  description(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  modifierType(): ModifierType {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ModifierType.BEFORE;
  }

  targetMessageTypeType(): MessageContent {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : MessageContent.NONE;
  }

  targetMessageType<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  direction(): ModifierDirection {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ModifierDirection.OUTBOUND;
  }

  priority(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  schemaVersion(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 1;
  }

  active(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  conditions(index: number, obj?: ModifierCondition): ModifierCondition | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset
      ? (obj || new ModifierCondition()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  conditionsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  actions(index: number, obj?: ModifierAction): ModifierAction | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset
      ? (obj || new ModifierAction()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  actionsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  payload(obj?: Message): Message | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset
      ? (obj || new Message()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  sourceMessageTypeType(): MessageContent {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : MessageContent.NONE;
  }

  /**
   * Added v2 — see schema_version. Discriminant-only filter on source channel messages.
   */
  sourceMessageType<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  /**
   * Added v3 — see schema_version. Directive for how the source
   * payload's value flows through to the target when this modifier
   * fires. PASSTHROUGH (default) preserves v1/v2 behavior.
   */
  valueTransformMode(): ValueTransformMode {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ValueTransformMode.PASSTHROUGH;
  }

  /**
   * SPECIFIC mode only: source values in `[value_range_start, value_range_end)`
   * match. Ignored for PASSTHROUGH and TRANSFORMATIVE modes.
   * `value_range_end == value_range_start` collapses to "match the
   * single value `range_start`" via the open-upper-bound convention —
   * callers wanting an inclusive single match should set
   * `value_range_end = value_range_start + 1`.
   */
  valueRangeStart(): number {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  valueRangeEnd(): number {
    const offset = this.bb!.__offset(this.bb_pos, 46);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * TRANSFORMATIVE mode only: `target_value = source_value + value_transform_offset`.
   * Signed so negative offsets work. Ignored for PASSTHROUGH and
   * SPECIFIC modes.
   */
  valueTransformOffset(): number {
    const offset = this.bb!.__offset(this.bb_pos, 48);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * Added v4 — see schema_version. The EXACT source leaf the modifier fires
   * on, stored as the same (content, value) scalar pair adapter keys use
   * (see `Key` in adapter.fbs). This sidesteps the union discriminant-only
   * round-trip drop that previously lost the source message kind: a union
   * discriminant with a null value collapses to NONE on the Go Object-API
   * unpack. `source_message_type` (the union above) is retained for wire
   * compatibility, but `source_message_content` + `source_message_value`
   * are authoritative for the source leaf going forward.
   */
  sourceMessageContent(): number {
    const offset = this.bb!.__offset(this.bb_pos, 50);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  sourceMessageValue(): number {
    const offset = this.bb!.__offset(this.bb_pos, 52);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * Added v5 — see schema_version. Ordered expected-message sequence. For
   * BEFORE modifiers the original source message is held until every step
   * is observed (see `ModifierSequenceStep`); for INBOUND AFTER modifiers
   * (v7) the steps are observed for logging and metrics only.
   * Empty (the default) preserves the legacy ack-only BEFORE behavior.
   * Additive trailing field — VTS builds predating it ignore it; an absent
   * vector costs zero bytes.
   */
  expectedSequence(index: number, obj?: ModifierSequenceStep): ModifierSequenceStep | null {
    const offset = this.bb!.__offset(this.bb_pos, 54);
    return offset
      ? (obj || new ModifierSequenceStep()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  expectedSequenceLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 54);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Added v6 — see schema_version. Conflict-resolution policy applied when
   * multiple BEFORE/AFTER modifiers emit to the SAME target channel + target
   * message. The highest-precedence (lowest `priority`) modifier in the group
   * governs; its `conflict_policy` decides the lower-precedence modifiers'
   * fate. COEXIST (0, the default) preserves the legacy all-fire behavior so
   * pre-v6 rows are byte-identical. Additive trailing scalar — VTS builds
   * predating it read the default 0. See `ConflictPolicy` in enums.fbs.
   */
  conflictPolicy(): ConflictPolicy {
    const offset = this.bb!.__offset(this.bb_pos, 56);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ConflictPolicy.COEXIST;
  }

  /**
   * Added v7 — see schema_version. The `active` flag stamped on the payload's
   * valued message when it is sent. `UNSET` (the default) is the pre-v7
   * behavior, `active: true`. Vendor command maps key on the whole valued
   * message, so this is what lets one payload message select opposite
   * commands — for example a relay's on and off.
   * Added v9: `MIRROR` copies the source message's `active` and `INVERT`
   * sends its opposite, so one modifier follows its source both ways (an
   * energize and its release) where `ACTIVE` / `INACTIVE` fix the level.
   * A row that uses either must carry `schema_version` 9 or later.
   */
  payloadActive(): ActiveState {
    const offset = this.bb!.__offset(this.bb_pos, 58);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ActiveState.UNSET;
  }

  /**
   * Added v7 — see schema_version. What a BEFORE modifier does with the held
   * source message when its gate fails. RELEASE (the default) is the pre-v7
   * fail-open behavior. See `ModifierTimeoutPolicy` in enums.fbs.
   */
  timeoutPolicy(): ModifierTimeoutPolicy {
    const offset = this.bb!.__offset(this.bb_pos, 60);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ModifierTimeoutPolicy.RELEASE;
  }

  /**
   * Added v7 — see schema_version. What VTS sends to the target after a
   * DROP. NONE (the default) sends nothing. See `ModifierDropAction`.
   */
  dropAction(): ModifierDropAction {
    const offset = this.bb!.__offset(this.bb_pos, 62);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ModifierDropAction.NONE;
  }

  /**
   * Added v7 — see schema_version. The channel every expected step is
   * observed on. Absent means the target channel, the pre-v7 behavior. Must
   * be on the same server as the source, and for BEFORE must not be the
   * source channel itself (the source's loop is held while the gate waits).
   */
  observeChannelId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 64);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * The message kind the modifier targets: a `MessageContent` discriminant
   * (u8 range 0..=9 widened to short, the same value space as
   * `source_message_content`). It is the scalar form of `target_message_type`
   * above. That union cannot carry a bare kind: a discriminant with no value
   * table is dropped by the Go Object-API unpack and rejected by the Rust
   * verifier, and a value table must hold its category's required message.
   * Writers set this field. Readers take it when non-zero and fall back to
   * `target_message_type` when it is 0, which is also how a buffer written
   * before this field reads.
   *
   * Added after v7 WITHOUT raising schema_version. It restates a field every
   * version already has and changes no runtime behavior, while VTS skips any
   * modifier whose schema_version is above the highest it knows, so a bump
   * would disable modifiers on every VTS not yet upgraded. Additive trailing
   * scalar — older readers ignore it.
   */
  targetMessageContent(): number {
    const offset = this.bb!.__offset(this.bb_pos, 66);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  /**
   * Added v8 — see schema_version. Conditions on current channel state; the
   * modifier acts only when every one holds. Empty (the default) always acts,
   * the pre-v8 behaviour. See `ModifierStateCondition`.
   */
  preconditions(index: number, obj?: ModifierStateCondition): ModifierStateCondition | null {
    const offset = this.bb!.__offset(this.bb_pos, 68);
    return offset
      ? (obj || new ModifierStateCondition()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  preconditionsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 68);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Added v8 — see schema_version. Time budget, in milliseconds, for the
   * steps after `RELEASE`; 0 means the runtime default of 10 minutes. Those
   * steps run without holding the source channel's loop, so this budget is
   * not capped at the 30 s that bounds the steps before the release.
   */
  postReleaseBudgetMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 70);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  static startChannelModifier(builder: flatbuffers.Builder) {
    builder.startObject(34);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addSourceChannelId(
    builder: flatbuffers.Builder,
    sourceChannelIdOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(1, sourceChannelIdOffset, 0);
  }

  static addTargetChannelId(
    builder: flatbuffers.Builder,
    targetChannelIdOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(2, targetChannelIdOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, nameOffset, 0);
  }

  static addDescription(builder: flatbuffers.Builder, descriptionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, descriptionOffset, 0);
  }

  static addModifierType(builder: flatbuffers.Builder, modifierType: ModifierType) {
    builder.addFieldInt8(5, modifierType, ModifierType.BEFORE);
  }

  static addTargetMessageTypeType(
    builder: flatbuffers.Builder,
    targetMessageTypeType: MessageContent,
  ) {
    builder.addFieldInt8(6, targetMessageTypeType, MessageContent.NONE);
  }

  static addTargetMessageType(
    builder: flatbuffers.Builder,
    targetMessageTypeOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(7, targetMessageTypeOffset, 0);
  }

  static addDirection(builder: flatbuffers.Builder, direction: ModifierDirection) {
    builder.addFieldInt8(8, direction, ModifierDirection.OUTBOUND);
  }

  static addPriority(builder: flatbuffers.Builder, priority: number) {
    builder.addFieldInt32(9, priority, 0);
  }

  static addSchemaVersion(builder: flatbuffers.Builder, schemaVersion: number) {
    builder.addFieldInt32(10, schemaVersion, 1);
  }

  static addActive(builder: flatbuffers.Builder, active: boolean) {
    builder.addFieldInt8(11, +active, +true);
  }

  static addConditions(builder: flatbuffers.Builder, conditionsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(12, conditionsOffset, 0);
  }

  static createConditionsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startConditionsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addActions(builder: flatbuffers.Builder, actionsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(13, actionsOffset, 0);
  }

  static createActionsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startActionsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addPayload(builder: flatbuffers.Builder, payloadOffset: flatbuffers.Offset) {
    builder.addFieldOffset(14, payloadOffset, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(15, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(16, updatedAtOffset, 0);
  }

  static addSourceMessageTypeType(
    builder: flatbuffers.Builder,
    sourceMessageTypeType: MessageContent,
  ) {
    builder.addFieldInt8(17, sourceMessageTypeType, MessageContent.NONE);
  }

  static addSourceMessageType(
    builder: flatbuffers.Builder,
    sourceMessageTypeOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(18, sourceMessageTypeOffset, 0);
  }

  static addValueTransformMode(
    builder: flatbuffers.Builder,
    valueTransformMode: ValueTransformMode,
  ) {
    builder.addFieldInt8(19, valueTransformMode, ValueTransformMode.PASSTHROUGH);
  }

  static addValueRangeStart(builder: flatbuffers.Builder, valueRangeStart: number) {
    builder.addFieldInt32(20, valueRangeStart, 0);
  }

  static addValueRangeEnd(builder: flatbuffers.Builder, valueRangeEnd: number) {
    builder.addFieldInt32(21, valueRangeEnd, 0);
  }

  static addValueTransformOffset(builder: flatbuffers.Builder, valueTransformOffset: number) {
    builder.addFieldInt32(22, valueTransformOffset, 0);
  }

  static addSourceMessageContent(builder: flatbuffers.Builder, sourceMessageContent: number) {
    builder.addFieldInt16(23, sourceMessageContent, 0);
  }

  static addSourceMessageValue(builder: flatbuffers.Builder, sourceMessageValue: number) {
    builder.addFieldInt32(24, sourceMessageValue, 0);
  }

  static addExpectedSequence(
    builder: flatbuffers.Builder,
    expectedSequenceOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(25, expectedSequenceOffset, 0);
  }

  static createExpectedSequenceVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startExpectedSequenceVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addConflictPolicy(builder: flatbuffers.Builder, conflictPolicy: ConflictPolicy) {
    builder.addFieldInt8(26, conflictPolicy, ConflictPolicy.COEXIST);
  }

  static addPayloadActive(builder: flatbuffers.Builder, payloadActive: ActiveState) {
    builder.addFieldInt8(27, payloadActive, ActiveState.UNSET);
  }

  static addTimeoutPolicy(builder: flatbuffers.Builder, timeoutPolicy: ModifierTimeoutPolicy) {
    builder.addFieldInt8(28, timeoutPolicy, ModifierTimeoutPolicy.RELEASE);
  }

  static addDropAction(builder: flatbuffers.Builder, dropAction: ModifierDropAction) {
    builder.addFieldInt8(29, dropAction, ModifierDropAction.NONE);
  }

  static addObserveChannelId(
    builder: flatbuffers.Builder,
    observeChannelIdOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(30, observeChannelIdOffset, 0);
  }

  static addTargetMessageContent(builder: flatbuffers.Builder, targetMessageContent: number) {
    builder.addFieldInt16(31, targetMessageContent, 0);
  }

  static addPreconditions(builder: flatbuffers.Builder, preconditionsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(32, preconditionsOffset, 0);
  }

  static createPreconditionsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startPreconditionsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addPostReleaseBudgetMs(builder: flatbuffers.Builder, postReleaseBudgetMs: number) {
    builder.addFieldInt32(33, postReleaseBudgetMs, 0);
  }

  static endChannelModifier(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // source_channel_id
    builder.requiredField(offset, 8); // target_channel_id
    builder.requiredField(offset, 10); // name
    return offset;
  }

  unpack(): ChannelModifierT {
    return new ChannelModifierT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.sourceChannelId() !== null ? this.sourceChannelId()!.unpack() : null,
      this.targetChannelId() !== null ? this.targetChannelId()!.unpack() : null,
      this.name(),
      this.description(),
      this.modifierType(),
      this.targetMessageTypeType(),
      (() => {
        const temp = unionToMessageContent(
          this.targetMessageTypeType(),
          this.targetMessageType.bind(this),
        );
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
      this.direction(),
      this.priority(),
      this.schemaVersion(),
      this.active(),
      this.bb!.createObjList<ModifierCondition, ModifierConditionT>(
        this.conditions.bind(this),
        this.conditionsLength(),
      ),
      this.bb!.createObjList<ModifierAction, ModifierActionT>(
        this.actions.bind(this),
        this.actionsLength(),
      ),
      this.payload() !== null ? this.payload()!.unpack() : null,
      this.createdAt(),
      this.updatedAt(),
      this.sourceMessageTypeType(),
      (() => {
        const temp = unionToMessageContent(
          this.sourceMessageTypeType(),
          this.sourceMessageType.bind(this),
        );
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
      this.valueTransformMode(),
      this.valueRangeStart(),
      this.valueRangeEnd(),
      this.valueTransformOffset(),
      this.sourceMessageContent(),
      this.sourceMessageValue(),
      this.bb!.createObjList<ModifierSequenceStep, ModifierSequenceStepT>(
        this.expectedSequence.bind(this),
        this.expectedSequenceLength(),
      ),
      this.conflictPolicy(),
      this.payloadActive(),
      this.timeoutPolicy(),
      this.dropAction(),
      this.observeChannelId() !== null ? this.observeChannelId()!.unpack() : null,
      this.targetMessageContent(),
      this.bb!.createObjList<ModifierStateCondition, ModifierStateConditionT>(
        this.preconditions.bind(this),
        this.preconditionsLength(),
      ),
      this.postReleaseBudgetMs(),
    );
  }

  unpackTo(_o: ChannelModifierT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.sourceChannelId = this.sourceChannelId() !== null ? this.sourceChannelId()!.unpack() : null;
    _o.targetChannelId = this.targetChannelId() !== null ? this.targetChannelId()!.unpack() : null;
    _o.name = this.name();
    _o.description = this.description();
    _o.modifierType = this.modifierType();
    _o.targetMessageTypeType = this.targetMessageTypeType();
    _o.targetMessageType = (() => {
      const temp = unionToMessageContent(
        this.targetMessageTypeType(),
        this.targetMessageType.bind(this),
      );
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
    _o.direction = this.direction();
    _o.priority = this.priority();
    _o.schemaVersion = this.schemaVersion();
    _o.active = this.active();
    _o.conditions = this.bb!.createObjList<ModifierCondition, ModifierConditionT>(
      this.conditions.bind(this),
      this.conditionsLength(),
    );
    _o.actions = this.bb!.createObjList<ModifierAction, ModifierActionT>(
      this.actions.bind(this),
      this.actionsLength(),
    );
    _o.payload = this.payload() !== null ? this.payload()!.unpack() : null;
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.sourceMessageTypeType = this.sourceMessageTypeType();
    _o.sourceMessageType = (() => {
      const temp = unionToMessageContent(
        this.sourceMessageTypeType(),
        this.sourceMessageType.bind(this),
      );
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
    _o.valueTransformMode = this.valueTransformMode();
    _o.valueRangeStart = this.valueRangeStart();
    _o.valueRangeEnd = this.valueRangeEnd();
    _o.valueTransformOffset = this.valueTransformOffset();
    _o.sourceMessageContent = this.sourceMessageContent();
    _o.sourceMessageValue = this.sourceMessageValue();
    _o.expectedSequence = this.bb!.createObjList<ModifierSequenceStep, ModifierSequenceStepT>(
      this.expectedSequence.bind(this),
      this.expectedSequenceLength(),
    );
    _o.conflictPolicy = this.conflictPolicy();
    _o.payloadActive = this.payloadActive();
    _o.timeoutPolicy = this.timeoutPolicy();
    _o.dropAction = this.dropAction();
    _o.observeChannelId =
      this.observeChannelId() !== null ? this.observeChannelId()!.unpack() : null;
    _o.targetMessageContent = this.targetMessageContent();
    _o.preconditions = this.bb!.createObjList<ModifierStateCondition, ModifierStateConditionT>(
      this.preconditions.bind(this),
      this.preconditionsLength(),
    );
    _o.postReleaseBudgetMs = this.postReleaseBudgetMs();
  }

  unpackFields(...fields: string[]): ChannelModifierT {
    const t = new ChannelModifierT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("source_channel_id")) {
      t.sourceChannelId = this.sourceChannelId() !== null ? this.sourceChannelId()!.unpack() : null;
    }
    if (fieldSet.has("target_channel_id")) {
      t.targetChannelId = this.targetChannelId() !== null ? this.targetChannelId()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("description")) {
      t.description = this.description();
    }
    if (fieldSet.has("modifier_type")) {
      t.modifierType = this.modifierType();
    }
    if (fieldSet.has("target_message_type_type")) {
      t.targetMessageTypeType = this.targetMessageTypeType();
    }
    if (fieldSet.has("target_message_type")) {
      t.targetMessageType = (() => {
        const temp = unionToMessageContent(
          this.targetMessageTypeType(),
          this.targetMessageType.bind(this),
        );
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    if (fieldSet.has("direction")) {
      t.direction = this.direction();
    }
    if (fieldSet.has("priority")) {
      t.priority = this.priority();
    }
    if (fieldSet.has("schema_version")) {
      t.schemaVersion = this.schemaVersion();
    }
    if (fieldSet.has("active")) {
      t.active = this.active();
    }
    if (fieldSet.has("conditions")) {
      t.conditions = this.bb!.createObjList<ModifierCondition, ModifierConditionT>(
        this.conditions.bind(this),
        this.conditionsLength(),
      );
    }
    if (fieldSet.has("actions")) {
      t.actions = this.bb!.createObjList<ModifierAction, ModifierActionT>(
        this.actions.bind(this),
        this.actionsLength(),
      );
    }
    if (fieldSet.has("payload")) {
      t.payload = this.payload() !== null ? this.payload()!.unpack() : null;
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("source_message_type_type")) {
      t.sourceMessageTypeType = this.sourceMessageTypeType();
    }
    if (fieldSet.has("source_message_type")) {
      t.sourceMessageType = (() => {
        const temp = unionToMessageContent(
          this.sourceMessageTypeType(),
          this.sourceMessageType.bind(this),
        );
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    if (fieldSet.has("value_transform_mode")) {
      t.valueTransformMode = this.valueTransformMode();
    }
    if (fieldSet.has("value_range_start")) {
      t.valueRangeStart = this.valueRangeStart();
    }
    if (fieldSet.has("value_range_end")) {
      t.valueRangeEnd = this.valueRangeEnd();
    }
    if (fieldSet.has("value_transform_offset")) {
      t.valueTransformOffset = this.valueTransformOffset();
    }
    if (fieldSet.has("source_message_content")) {
      t.sourceMessageContent = this.sourceMessageContent();
    }
    if (fieldSet.has("source_message_value")) {
      t.sourceMessageValue = this.sourceMessageValue();
    }
    if (fieldSet.has("expected_sequence")) {
      t.expectedSequence = this.bb!.createObjList<ModifierSequenceStep, ModifierSequenceStepT>(
        this.expectedSequence.bind(this),
        this.expectedSequenceLength(),
      );
    }
    if (fieldSet.has("conflict_policy")) {
      t.conflictPolicy = this.conflictPolicy();
    }
    if (fieldSet.has("payload_active")) {
      t.payloadActive = this.payloadActive();
    }
    if (fieldSet.has("timeout_policy")) {
      t.timeoutPolicy = this.timeoutPolicy();
    }
    if (fieldSet.has("drop_action")) {
      t.dropAction = this.dropAction();
    }
    if (fieldSet.has("observe_channel_id")) {
      t.observeChannelId =
        this.observeChannelId() !== null ? this.observeChannelId()!.unpack() : null;
    }
    if (fieldSet.has("target_message_content")) {
      t.targetMessageContent = this.targetMessageContent();
    }
    if (fieldSet.has("preconditions")) {
      t.preconditions = this.bb!.createObjList<ModifierStateCondition, ModifierStateConditionT>(
        this.preconditions.bind(this),
        this.preconditionsLength(),
      );
    }
    if (fieldSet.has("post_release_budget_ms")) {
      t.postReleaseBudgetMs = this.postReleaseBudgetMs();
    }
    return t;
  }
}

export class ChannelModifierT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public sourceChannelId: UuidT | null = null,
    public targetChannelId: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public description: string | Uint8Array | null = null,
    public modifierType: ModifierType = ModifierType.BEFORE,
    public targetMessageTypeType: MessageContent = MessageContent.NONE,
    public targetMessageType:
      | ControlMessageT
      | ControllerInfoMessageT
      | FaultMessageT
      | GroupControlMessageT
      | GroupSupervisoryStatusMessageT
      | ServiceMessageT
      | StatusMessageT
      | TrafficMessageT
      | UsageMessageT
      | null = null,
    public direction: ModifierDirection = ModifierDirection.OUTBOUND,
    public priority: number = 0,
    public schemaVersion: number = 1,
    public active: boolean = true,
    public conditions: ModifierConditionT[] = [],
    public actions: ModifierActionT[] = [],
    public payload: MessageT | null = null,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public sourceMessageTypeType: MessageContent = MessageContent.NONE,
    public sourceMessageType:
      | ControlMessageT
      | ControllerInfoMessageT
      | FaultMessageT
      | GroupControlMessageT
      | GroupSupervisoryStatusMessageT
      | ServiceMessageT
      | StatusMessageT
      | TrafficMessageT
      | UsageMessageT
      | null = null,
    public valueTransformMode: ValueTransformMode = ValueTransformMode.PASSTHROUGH,
    public valueRangeStart: number = 0,
    public valueRangeEnd: number = 0,
    public valueTransformOffset: number = 0,
    public sourceMessageContent: number = 0,
    public sourceMessageValue: number = 0,
    public expectedSequence: ModifierSequenceStepT[] = [],
    public conflictPolicy: ConflictPolicy = ConflictPolicy.COEXIST,
    public payloadActive: ActiveState = ActiveState.UNSET,
    public timeoutPolicy: ModifierTimeoutPolicy = ModifierTimeoutPolicy.RELEASE,
    public dropAction: ModifierDropAction = ModifierDropAction.NONE,
    public observeChannelId: UuidT | null = null,
    public targetMessageContent: number = 0,
    public preconditions: ModifierStateConditionT[] = [],
    public postReleaseBudgetMs: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.sourceChannelId === null || this.sourceChannelId === undefined) {
      throw new Error('Required field "source_channel_id" is not set');
    }
    if (this.targetChannelId === null || this.targetChannelId === undefined) {
      throw new Error('Required field "target_channel_id" is not set');
    }
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const sourceChannelId = this.sourceChannelId !== null ? this.sourceChannelId!.pack(builder) : 0;
    const targetChannelId = this.targetChannelId !== null ? this.targetChannelId!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const description = this.description !== null ? builder.createString(this.description!) : 0;
    const targetMessageType = builder.createObjectOffset(this.targetMessageType);
    const conditions = ChannelModifier.createConditionsVector(
      builder,
      builder.createObjectOffsetList(this.conditions),
    );
    const actions = ChannelModifier.createActionsVector(
      builder,
      builder.createObjectOffsetList(this.actions),
    );
    const payload = this.payload !== null ? this.payload!.pack(builder) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const sourceMessageType = builder.createObjectOffset(this.sourceMessageType);
    const expectedSequence = ChannelModifier.createExpectedSequenceVector(
      builder,
      builder.createObjectOffsetList(this.expectedSequence),
    );
    const observeChannelId =
      this.observeChannelId !== null ? this.observeChannelId!.pack(builder) : 0;
    const preconditions = ChannelModifier.createPreconditionsVector(
      builder,
      builder.createObjectOffsetList(this.preconditions),
    );

    ChannelModifier.startChannelModifier(builder);
    ChannelModifier.addId(builder, id);
    ChannelModifier.addSourceChannelId(builder, sourceChannelId);
    ChannelModifier.addTargetChannelId(builder, targetChannelId);
    ChannelModifier.addName(builder, name);
    ChannelModifier.addDescription(builder, description);
    ChannelModifier.addModifierType(builder, this.modifierType);
    ChannelModifier.addTargetMessageTypeType(builder, this.targetMessageTypeType);
    ChannelModifier.addTargetMessageType(builder, targetMessageType);
    ChannelModifier.addDirection(builder, this.direction);
    ChannelModifier.addPriority(builder, this.priority);
    ChannelModifier.addSchemaVersion(builder, this.schemaVersion);
    ChannelModifier.addActive(builder, this.active);
    ChannelModifier.addConditions(builder, conditions);
    ChannelModifier.addActions(builder, actions);
    ChannelModifier.addPayload(builder, payload);
    ChannelModifier.addCreatedAt(builder, createdAt);
    ChannelModifier.addUpdatedAt(builder, updatedAt);
    ChannelModifier.addSourceMessageTypeType(builder, this.sourceMessageTypeType);
    ChannelModifier.addSourceMessageType(builder, sourceMessageType);
    ChannelModifier.addValueTransformMode(builder, this.valueTransformMode);
    ChannelModifier.addValueRangeStart(builder, this.valueRangeStart);
    ChannelModifier.addValueRangeEnd(builder, this.valueRangeEnd);
    ChannelModifier.addValueTransformOffset(builder, this.valueTransformOffset);
    ChannelModifier.addSourceMessageContent(builder, this.sourceMessageContent);
    ChannelModifier.addSourceMessageValue(builder, this.sourceMessageValue);
    ChannelModifier.addExpectedSequence(builder, expectedSequence);
    ChannelModifier.addConflictPolicy(builder, this.conflictPolicy);
    ChannelModifier.addPayloadActive(builder, this.payloadActive);
    ChannelModifier.addTimeoutPolicy(builder, this.timeoutPolicy);
    ChannelModifier.addDropAction(builder, this.dropAction);
    ChannelModifier.addObserveChannelId(builder, observeChannelId);
    ChannelModifier.addTargetMessageContent(builder, this.targetMessageContent);
    ChannelModifier.addPreconditions(builder, preconditions);
    ChannelModifier.addPostReleaseBudgetMs(builder, this.postReleaseBudgetMs);

    return ChannelModifier.endChannelModifier(builder);
  }

  clone(): ChannelModifierT {
    const obj = new ChannelModifierT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.sourceChannelId = this.sourceChannelId !== null ? this.sourceChannelId!.clone() : null;
    obj.targetChannelId = this.targetChannelId !== null ? this.targetChannelId!.clone() : null;
    obj.name = this.name;
    obj.description = this.description;
    obj.modifierType = this.modifierType;
    obj.targetMessageTypeType = this.targetMessageTypeType;
    obj.targetMessageType =
      this.targetMessageType !== null && typeof (this.targetMessageType as any).clone === "function"
        ? (this.targetMessageType as any).clone()
        : this.targetMessageType;
    obj.direction = this.direction;
    obj.priority = this.priority;
    obj.schemaVersion = this.schemaVersion;
    obj.active = this.active;
    obj.conditions = this.conditions.map((e) => e.clone());
    obj.actions = this.actions.map((e) => e.clone());
    obj.payload = this.payload !== null ? this.payload!.clone() : null;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.sourceMessageTypeType = this.sourceMessageTypeType;
    obj.sourceMessageType =
      this.sourceMessageType !== null && typeof (this.sourceMessageType as any).clone === "function"
        ? (this.sourceMessageType as any).clone()
        : this.sourceMessageType;
    obj.valueTransformMode = this.valueTransformMode;
    obj.valueRangeStart = this.valueRangeStart;
    obj.valueRangeEnd = this.valueRangeEnd;
    obj.valueTransformOffset = this.valueTransformOffset;
    obj.sourceMessageContent = this.sourceMessageContent;
    obj.sourceMessageValue = this.sourceMessageValue;
    obj.expectedSequence = this.expectedSequence.map((e) => e.clone());
    obj.conflictPolicy = this.conflictPolicy;
    obj.payloadActive = this.payloadActive;
    obj.timeoutPolicy = this.timeoutPolicy;
    obj.dropAction = this.dropAction;
    obj.observeChannelId = this.observeChannelId !== null ? this.observeChannelId!.clone() : null;
    obj.targetMessageContent = this.targetMessageContent;
    obj.preconditions = this.preconditions.map((e) => e.clone());
    obj.postReleaseBudgetMs = this.postReleaseBudgetMs;
    return obj;
  }

  equals(other: ChannelModifierT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.sourceChannelId !== null && other.sourceChannelId !== null) {
      if (!this.sourceChannelId!.equals(other.sourceChannelId!)) return false;
    } else if (this.sourceChannelId !== other.sourceChannelId) return false;
    if (this.targetChannelId !== null && other.targetChannelId !== null) {
      if (!this.targetChannelId!.equals(other.targetChannelId!)) return false;
    } else if (this.targetChannelId !== other.targetChannelId) return false;
    if (this.name !== other.name) return false;
    if (this.description !== other.description) return false;
    if (this.modifierType !== other.modifierType) return false;
    if (this.targetMessageTypeType !== other.targetMessageTypeType) return false;
    if (this.targetMessageType !== null && other.targetMessageType !== null) {
      if (typeof (this.targetMessageType as any).equals === "function") {
        if (!(this.targetMessageType as any).equals(other.targetMessageType)) return false;
      } else if (this.targetMessageType !== other.targetMessageType) return false;
    } else if (this.targetMessageType !== other.targetMessageType) return false;
    if (this.direction !== other.direction) return false;
    if (this.priority !== other.priority) return false;
    if (this.schemaVersion !== other.schemaVersion) return false;
    if (this.active !== other.active) return false;
    if (this.conditions.length !== other.conditions.length) return false;
    for (let i = 0; i < this.conditions.length; i++) {
      const a = this.conditions[i];
      const b = other.conditions[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.actions.length !== other.actions.length) return false;
    for (let i = 0; i < this.actions.length; i++) {
      const a = this.actions[i];
      const b = other.actions[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.payload !== null && other.payload !== null) {
      if (!this.payload!.equals(other.payload!)) return false;
    } else if (this.payload !== other.payload) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.sourceMessageTypeType !== other.sourceMessageTypeType) return false;
    if (this.sourceMessageType !== null && other.sourceMessageType !== null) {
      if (typeof (this.sourceMessageType as any).equals === "function") {
        if (!(this.sourceMessageType as any).equals(other.sourceMessageType)) return false;
      } else if (this.sourceMessageType !== other.sourceMessageType) return false;
    } else if (this.sourceMessageType !== other.sourceMessageType) return false;
    if (this.valueTransformMode !== other.valueTransformMode) return false;
    if (this.valueRangeStart !== other.valueRangeStart) return false;
    if (this.valueRangeEnd !== other.valueRangeEnd) return false;
    if (this.valueTransformOffset !== other.valueTransformOffset) return false;
    if (this.sourceMessageContent !== other.sourceMessageContent) return false;
    if (this.sourceMessageValue !== other.sourceMessageValue) return false;
    if (this.expectedSequence.length !== other.expectedSequence.length) return false;
    for (let i = 0; i < this.expectedSequence.length; i++) {
      const a = this.expectedSequence[i];
      const b = other.expectedSequence[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.conflictPolicy !== other.conflictPolicy) return false;
    if (this.payloadActive !== other.payloadActive) return false;
    if (this.timeoutPolicy !== other.timeoutPolicy) return false;
    if (this.dropAction !== other.dropAction) return false;
    if (this.observeChannelId !== null && other.observeChannelId !== null) {
      if (!this.observeChannelId!.equals(other.observeChannelId!)) return false;
    } else if (this.observeChannelId !== other.observeChannelId) return false;
    if (this.targetMessageContent !== other.targetMessageContent) return false;
    if (this.preconditions.length !== other.preconditions.length) return false;
    for (let i = 0; i < this.preconditions.length; i++) {
      const a = this.preconditions[i];
      const b = other.preconditions[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.postReleaseBudgetMs !== other.postReleaseBudgetMs) return false;
    return true;
  }
}

export function verifyChannelModifier(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "source_channel_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "target_channel_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "name");
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 14, 1);
    verifier.checkScalarField(tablePos, 16, 1);
    verifier.checkUnionConsistency(tablePos, 16, 18, "target_message_type");
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 16);
        switch (uType) {
          case 1: // Status_StatusMessage
            {
              const o = verifier.readInt32(pos);
              verifyStatusMessage(verifier, pos + o);
            }
            break;
          case 2: // Traffic_TrafficMessage
            {
              const o = verifier.readInt32(pos);
              verifyTrafficMessage(verifier, pos + o);
            }
            break;
          case 3: // Usage_UsageMessage
            {
              const o = verifier.readInt32(pos);
              verifyUsageMessage(verifier, pos + o);
            }
            break;
          case 4: // Service_ServiceMessage
            {
              const o = verifier.readInt32(pos);
              verifyServiceMessage(verifier, pos + o);
            }
            break;
          case 5: // Control_ControlMessage
            {
              const o = verifier.readInt32(pos);
              verifyControlMessage(verifier, pos + o);
            }
            break;
          case 6: // Fault_FaultMessage
            {
              const o = verifier.readInt32(pos);
              verifyFaultMessage(verifier, pos + o);
            }
            break;
          case 7: // GroupSupervisoryStatus_GroupSupervisoryStatusMessage
            {
              const o = verifier.readInt32(pos);
              verifyGroupSupervisoryStatusMessage(verifier, pos + o);
            }
            break;
          case 8: // GroupControl_GroupControlMessage
            {
              const o = verifier.readInt32(pos);
              verifyGroupControlMessage(verifier, pos + o);
            }
            break;
          case 9: // ControllerInfo_ControllerInfoMessage
            {
              const o = verifier.readInt32(pos);
              verifyControllerInfoMessage(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkScalarField(tablePos, 20, 1);
    verifier.checkScalarField(tablePos, 22, 4);
    verifier.checkScalarField(tablePos, 24, 4);
    verifier.checkScalarField(tablePos, 26, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 28);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyModifierCondition);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 30);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyModifierAction);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 32);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyMessage(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 34);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 36);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 38, 1);
    verifier.checkUnionConsistency(tablePos, 38, 40, "source_message_type");
    {
      const pos = verifier.checkOffsetField(tablePos, 40);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 38);
        switch (uType) {
          case 1: // Status_StatusMessage
            {
              const o = verifier.readInt32(pos);
              verifyStatusMessage(verifier, pos + o);
            }
            break;
          case 2: // Traffic_TrafficMessage
            {
              const o = verifier.readInt32(pos);
              verifyTrafficMessage(verifier, pos + o);
            }
            break;
          case 3: // Usage_UsageMessage
            {
              const o = verifier.readInt32(pos);
              verifyUsageMessage(verifier, pos + o);
            }
            break;
          case 4: // Service_ServiceMessage
            {
              const o = verifier.readInt32(pos);
              verifyServiceMessage(verifier, pos + o);
            }
            break;
          case 5: // Control_ControlMessage
            {
              const o = verifier.readInt32(pos);
              verifyControlMessage(verifier, pos + o);
            }
            break;
          case 6: // Fault_FaultMessage
            {
              const o = verifier.readInt32(pos);
              verifyFaultMessage(verifier, pos + o);
            }
            break;
          case 7: // GroupSupervisoryStatus_GroupSupervisoryStatusMessage
            {
              const o = verifier.readInt32(pos);
              verifyGroupSupervisoryStatusMessage(verifier, pos + o);
            }
            break;
          case 8: // GroupControl_GroupControlMessage
            {
              const o = verifier.readInt32(pos);
              verifyGroupControlMessage(verifier, pos + o);
            }
            break;
          case 9: // ControllerInfo_ControllerInfoMessage
            {
              const o = verifier.readInt32(pos);
              verifyControllerInfoMessage(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkScalarField(tablePos, 42, 1);
    verifier.checkScalarField(tablePos, 44, 4);
    verifier.checkScalarField(tablePos, 46, 4);
    verifier.checkScalarField(tablePos, 48, 4);
    verifier.checkScalarField(tablePos, 50, 2);
    verifier.checkScalarField(tablePos, 52, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 54);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyModifierSequenceStep);
      }
    }
    verifier.checkScalarField(tablePos, 56, 1);
    verifier.checkScalarField(tablePos, 58, 1);
    verifier.checkScalarField(tablePos, 60, 1);
    verifier.checkScalarField(tablePos, 62, 1);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 64);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 66, 2);
    {
      const pos = verifier.checkOffsetField(tablePos, 68);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyModifierStateCondition);
      }
    }
    verifier.checkScalarField(tablePos, 70, 4);
  } finally {
    verifier.popDepth();
  }
}
